import type { AxiosError } from 'axios';
import { createQuery } from 'react-query-kit';

import { client } from '@/api/common';
import type { Payout } from '@/api/reservations';

type Variables = { id: string };
type Response = Payout;

export const usePayout = createQuery<Response, Variables, AxiosError>({
  queryKey: ['payout'],
  fetcher: ({ id }) => {
    return client.get(`v2/payouts/${id}`).then((response) => {
      return response.data.data;
    });
  },
});
